import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppSelector } from '../hooks';
import * as LWIcon from '../components/LWIcon';
import { DeviceLink } from '../features/devices/DeviceLink';
import { selectWidgetForDevice } from '../reducers/SelectWidgetForDevice';
import { EntityNexaDim } from './EntityNexaDim';
import { EntityOnOff } from './EntityOnOff';
import { EntityOnOffUnknown } from './EntityOnOffUnknown';
import { EntityHasta } from './EntityHasta';
export const PanelDevice = (props) => {
    const devices = useAppSelector(state => state.definitions.devices);
    const widget = useAppSelector(state => selectWidgetForDevice(state, props.device_id));
    const device = devices[props.device_id];
    if (device == undefined) {
        return (_jsx("div", { children: "Unknown device" }));
    }
    let buttons;
    let hasDimmer = false;
    switch (widget === null || widget === void 0 ? void 0 : widget.kind) {
        case 'NexaDimmer':
            buttons = (_jsx(EntityNexaDim, { entity: widget.entity, actionOnOff: widget.actionOnOff, actionLevel: widget.actionLevel }));
            break;
        case 'Light':
            hasDimmer = widget.level != undefined;
            buttons = widget.onoff ? (_jsx(EntityOnOff, { entity: widget.onoff.entity, action: widget.onoff.action })) : null;
            break;
        case 'OnOffUnknown':
            buttons = (_jsx(EntityOnOffUnknown, { entity: widget.entity, action: widget.action }));
            break;
        case 'Shades':
            buttons = (_jsx(EntityHasta, { entity: widget.entity, action: widget.action }));
            break;
    }
    let dimmerSymbol;
    if (hasDimmer) {
        dimmerSymbol = (_jsxs(React.Fragment, { children: [_jsx("div", { style: { color: '#aca' }, children: _jsx(LWIcon.Dimmer, {}) }), "\u00A0"] }));
    }
    else {
        dimmerSymbol = '';
    }
    return (_jsxs("div", { style: { display: 'flex' }, className: "panel-transmitter", children: [_jsx("div", { style: { flex: 'auto', overflow: 'hidden' }, children: _jsx(DeviceLink, { device_id: props.device_id }) }), _jsxs("div", { style: { flex: 'initial', display: 'flex' }, children: [dimmerSymbol, buttons] })] }));
};
